import { render } from "./MentorBasePage.vue?vue&type=template&id=236b496d"
import script from "./MentorBasePage.vue?vue&type=script&lang=js"
export * from "./MentorBasePage.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__